import React, { useEffect, useState } from "react";
import ModalBox from "../../Components/modals/ModalBox";
import CreateForm from "./CreateModalContent/CreateForm";
import AddiionalInfoOptions from "./CreateModalContent/AddiionalInfoOptions";
import ContactInformation from "./CreateModalContent/ContactInformation";
import HomeInformation from "./CreateModalContent/HomeInformation";
import PersonalInformation from "./CreateModalContent/PersonalInformation";
import MedicalInformation from "./CreateModalContent/MedicalInformation";
import AdditionalOptions from "./CreateModalContent/AdditionalOptions";

function CreateRelationship(props) {

  const { showModal, closeModal,editKey, listingFn,profileEdit,getResponse,updateBillingInfo, showMoreInfo=false, isMaxineStar=false,type='' } = props;
  const [userKey, setUserKey] = useState(editKey);
  const [pageType, setPageType] = useState('');
  const [previewData, setPreviewData] = useState({});
  

  useEffect(() => {
    setPageType(showMoreInfo ? 'additional_info_opions' : type)
    // fetchData();
  }, [showModal]);
  
  const handleCreateSubmit = (data) => {
    // console.log(data);
    if(data.show_additional_info=='1'){
      setUserKey(data.id)
      setPreviewData(data);
      setPageType('additional_info_opions');
    }else{
      closeModal();
    }
  }

  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="lg"
      bodyClassName="accrdn-modal-body"
      hasData={true}
    >
      {(() => {
        switch (pageType) {
          case "additional_info_opions":
              return <AddiionalInfoOptions {...props} previewData={previewData} onSelect={(type)=>setPageType(type)} editKey={userKey}/>

          case "contact_information":
              return <ContactInformation {...props} editKey={userKey} handleBack={()=>setPageType('additional_info_opions')}/>
  
          case "home_information":
              return <HomeInformation {...props} editKey={userKey} handleBack={()=>setPageType('additional_info_opions')}/>
  
          case "personal_information":
              return <PersonalInformation {...props} editKey={userKey} handleBack={()=>setPageType('additional_info_opions')}/>
  
          case "medical_information":
              return <MedicalInformation {...props} editKey={userKey} handleBack={()=>setPageType('additional_info_opions')}/>

          case "additional_information":
              return <AdditionalOptions {...props} editKey={userKey} handleBack={()=>setPageType('additional_info_opions')}/>
        
          default:
            if(!showMoreInfo)
              return <CreateForm {...props} editKey={userKey} returnData={handleCreateSubmit}/>
          }
      })()}
      
    </ModalBox>
  );
}

export default CreateRelationship;
